import { Component, Inject } from '@angular/core';

import get from 'lodash/get';

import { ISitemap, SITEMAP } from 'pbc.angular';
import { ISorterConfig } from 'pbc.types';

import { ReisekostenabrechnungQuerySorterConfig } from 'fa-kt.types';
import { ReisekostenabrechnungService } from '../service';

@Component({
  selector: 'fa-kt-reisekostenabrechnung-sorter',
  templateUrl: './reisekostenabrechnung-sorter.component.html',
  styleUrls: ['./reisekostenabrechnung-sorter.component.css'],
})
export class ReisekostenabrechnungSorterComponent {
  public ReisekostenabrechnungSorterConfig: ISorterConfig;

  constructor(
    @Inject(SITEMAP) private sitemap: ISitemap,
    public reisekostenabrechnung: ReisekostenabrechnungService,
  ) {
    this.ReisekostenabrechnungSorterConfig = ReisekostenabrechnungQuerySorterConfig.map((filter) => ({ ...filter, title: get(sitemap, filter.title, filter.title) as string }));
    /* << update    */
    /*    update >> */
  }
}
